import { CashTypeName } from "../types";

export const cashTypeToString = (type: CashTypeName): string => {
  switch (type) {
    case "received":
      return "دریافتی";
    case "spent":
      return "خرج شده";
    default:
      return "unknown cash type";
  }
};
